import { AmostrasService, LotesService, ConservacaoService, EmpresasService } from "../../services";
import { formatarTitleCase } from '../../shared/utils/Formatacao';

const tratarOpcoesFiltro = (resultado) => {
	if (!resultado || !resultado.length)
		return [];

	resultado.forEach(res => {
		res.descricao = formatarTitleCase(res.descricao);
	});

	return resultado.sort((a, b) => a.descricao.localeCompare(b.descricao));
};


class DadosLotesManager {
	async listarEmpresas() {
		return await EmpresasService.listarEmpresas().then((res) => {
			if (res && res.data) {
            	res.data.sort((a, b)=>{return a.descricao.localeCompare(b.descricao)});
			}

			return res && res.data
		})
	}

	async listarAmostrasLote(filtros, uuid) {
		return await AmostrasService.listarAmostras(filtros, uuid).then((res) => {
			return res && res.data
		})
	}

	async listarTiposAmostra() {
		return await AmostrasService.listarTipos().then((res) => {
			return res && tratarOpcoesFiltro(res.data)
		})
	}

	async listarTiposLote() {
		return await LotesService.listarTiposLote().then((res) => {
			return res && res.data
		})
	}

	async listarTiposConservacaoLote(idTipoLote) {
		return await ConservacaoService.listarTipos(idTipoLote).then((res) => {
			return res && res.data
		})
	}

	async inserirAmostraLote(dados, loteKPA) {
		return await LotesService.inserirAmostraLote(dados, true, loteKPA).then((res) => {
			return res && res.data;
		})
	}

	async excluirAmostraLote(dados) {
		return await LotesService.excluirAmostraLote(dados, true).then((res) => {
			return res && res.data;
		})
	}

	async cadastrarLote(dados) {
		return await LotesService.cadastrarLote(dados).then((res) => {
			return res && res.data;
		})
	}

	async editarLote(dados) {
		return await LotesService.editarLote(dados).then((res) => {
			return res && res.status === 200;
		})
	}

	async obterDadosLote(idLote) {
		return await LotesService.obterDadosLote(idLote).then((res) => {
			return res && res.data;
		})
	}
}

export default new DadosLotesManager()